import { defineComponent as _defineComponent } from 'vue'
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { TitleOfferFragment } from '@/components/buybox/graphql/fragments/Offer.fragment';

import { ObjectType } from '@/@types/graphql-types';
import { useI18n } from '@/helpers/composables/useI18n';
import { OfferLocation } from '@/helpers/offer-helper';
import { SnowplowClickoutContextGraphql, SnowplowContext } from '@/helpers/tracking/providers';
// need to import this immediately because it's above the fold and could cause CLS
import BuyBoxOfferNew from '@/components/buybox-new/BuyBoxOfferNew.vue';
import { provide } from 'vue';

import { trackFreeTrialSwiperExp } from '../experiments/FreeTrialSwiperExp/tracking';
import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';
import { useBuyboxLoggedInExp } from '../experiments/BuyboxLoggedInExp/composables/useBuyboxLoggedInExp';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotedBuyBoxNew',
  props: {
    promotedOffers: null,
    objectType: null,
    title: null,
    additionalContexts: null,
    inPromotionCatalogue: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	promotedOffers: TitleOfferFragment[];
	objectType: ObjectType;
	title: TitleDetail;
	additionalContexts: SnowplowContext[];
	// FT_SWIPER_EXP
	inPromotionCatalogue?: boolean;
	// FT_SWIPER_EXP
};



const { tc } = useI18n();
useProvideClickoutPlacement('promoted_buybox');

provide('offerLocation', OfferLocation.PROMOTED_BUYBOX);

// BUYBOX_LOGGED_IN_EXP
const { trackBuyboxLoggedInExp } = useBuyboxLoggedInExp();
//BUYBOX_LOGGED_IN_EXP
function clickOut(payload: { buyboxOffer: TitleOfferFragment; isLeavingIconShown: boolean }) {
	// showPageRolloutTracking

	const clickoutContext = SnowplowClickoutContextGraphql.fromProviderOffer(payload.buyboxOffer);

	//FT_SWIPER_EXP
	if (!props.inPromotionCatalogue) {
		trackFreeTrialSwiperExp({
			action: 'click',
			label: 'clickout_promoted',
			contexts: [clickoutContext, ...props.additionalContexts],
		});
	}
	// FT_SWIPER_EXP

	trackBuyboxLoggedInExp({
		action: 'click',
		label: `clickout_new_buybox_promoted`,
		contexts: [clickoutContext],
	});
}

return { __sfc: true,props, tc, trackBuyboxLoggedInExp, clickOut, BuyBoxOfferNew }
}

})